import styled from 'styled-components'

/**
 * Generic SubHeader style wrapper that lists without any dependencies.
 * Typically follows a `<ul>` element.
 * @alias SubheaderNavModule
 * @example
  <Col xs={12} sm={9} className="device-nav-col">
    <StyledNavGenericWrapper>
      <ul>
        <DeviceContentCategories
          currentDevice={currentDevice}
          query={query}
          language={language}
          onSvgLoad={onSvgLoad}
          modulesAvailable={modulesAvailable}
          showHomeLink
          showExpressLink={false}
          version={version}
        />
      </ul>
    </StyledNavGenericWrapper>
  </Col>
 */
export const StyledNavGenericWrapper = styled.nav.attrs(() => {
  'animated fadeIn'
})`
  --navHeight: 3.75rem;
  margin-left: 38px;

  ul {
    display: flex;
    margin: 0 auto;
    padding: 0;
    flex-wrap: wrap;
  }

  li,
  span {
    color: var(--clr-nav-text);
    display: inline-block;
    vertical-align: middle;
    text-decoration: none;
    font-weight: 600;
    letter-spacing: 0.06em;
    text-transform: uppercase;
    font-size: 1rem;
    max-width: max-content;
  }

  li {
    flex: 1 0 140px;
    max-width: min-content;
    inline-size: fit-content;

    &:hover {
      background-color: rgba(255, 255, 255, 0.25);
    }
  }

  a {
    height: var(--navHeight);
    display: flex;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
    padding: 0 1.5em;
    cursor: pointer;
    text-decoration: none;
  }

  svg {
    min-height: var(--small-icon-size);
    min-width: var(--small-icon-size);
    fill: var(--white);
    margin: 5px 10px 5px 0px;
    display: inline-block;
    vertical-align: middle;
  }

  .active-nav {
    background-color: rgba(255, 255, 255, 0.25);
  }

  > ul > a:hover,
  > ul > a:focus {
    background-color: rgba(255, 255, 255, 0.35);
  }

  @media (min-width: 1200px) {
    margin-left: 0px;
  }

  @media (max-width: 991px) {
    margin-left: 15px;
  }

  @media (max-width: 767px) {
    border-top: 1px solid var(--clr-nav-text);
    margin-left: 0px;

    a {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }

    li,
    span {
      max-width: 50%;
    }

    span {
      display: block;
    }

    li {
      text-align: center;
      position: relative;
      height: var(--navHeight);
    }

    svg {
      margin: 5px 10px 5px 10px;
      height: var(--small-icon-size);
      width: var(--small-icon-size);
    }
  }
`

/** Name styled-components so they don't trace in ReactDevTools as anonymous `styled.div`s  */
/** Feel free to change in dev */
StyledNavGenericWrapper.displayName = 'StyledNavGenericWrapper'



// WEBPACK FOOTER //
// ./src/components/SubHeader/styled/StyledNavGenericWrapper.js